module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAA9ElEQVQoU22PsUrDUBSGv7+io86+gnQTlW7u4iho2qw6CW6WJohD7kOok0KioXTQ0dVFOgiCLyCOrh3ENj1yiylt9Iz//b9zvyMq03K2atAfG/FtrOvqu6pB4OxBsAN8jWArj/Q225kDgsRCiRuMfcSZQW04ZKN7rkEJTQGvMga/7TGLdBA6qxfQF/TSSOEfYKJiNL5rrHU7+vSFwNmh4MLgKIt06bPJD6WKGa0sVjrr3HSWA7ujBRp5W6+aqhjPWSx/7NzsndrK0jIvZhSDRdbVdHYPbBdG/S7WRxX4NdiUeEL0PPCOSNKOrv4rl1kzsRPE8Q+xSl8vr1muEgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shang.png
// module id = FUrt
// module chunks = 2